export default "__VITE_ASSET__BzTlWHe1__"